import { render, staticRenderFns } from "./produto_composicao.vue?vue&type=template&id=2c7a7d38"
import script from "./produto_composicao.vue?vue&type=script&lang=js"
export * from "./produto_composicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports